import { StringsContext } from '../lib/StringsContext';
import { useContext } from 'react';
import { getString } from '../components/string';

export const useGetString = () => {
  const strings = useContext(StringsContext);
  return (key: string, values?: Record<string, string | number>) =>
    getString(key, strings, false, values)?.value;
};
